var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFirstTimer(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 14,
    viewBox: "0 0 12 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.78125 0.625H6H7.21875C7.65039 0.625 8.03125 1.00586 8.03125 1.4375C8.03125 1.89453 7.65039 2.25 7.21875 2.25H6.8125V3.13867C7.75195 3.29102 8.61523 3.67188 9.32617 4.25586L9.88477 3.72266C10.1895 3.39258 10.7227 3.39258 11.0273 3.72266C11.3574 4.02734 11.3574 4.56055 11.0273 4.86523L10.418 5.47461C10.9512 6.3125 11.2812 7.30273 11.2812 8.34375C11.2812 11.2637 8.89453 13.625 6 13.625C3.08008 13.625 0.71875 11.2637 0.71875 8.34375C0.71875 5.70312 2.64844 3.51953 5.1875 3.13867V2.25H4.78125C4.32422 2.25 3.96875 1.89453 3.96875 1.4375C3.96875 1.00586 4.32422 0.625 4.78125 0.625ZM6.60938 5.5C6.60938 5.16992 6.33008 4.89062 6 4.89062C5.64453 4.89062 5.39062 5.16992 5.39062 5.5V8.75C5.39062 9.10547 5.64453 9.35938 6 9.35938C6.33008 9.35938 6.60938 9.10547 6.60938 8.75V5.5Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstTimer);
export default ForwardRef;